export const locale = {
    lang: 'es',
    data: {
        GRUAS: {
            ADD: {
                TITLE: 'NUEVA GRÚA'
            }
        }
    }
};
